import api from "../utils/api";

/**
 * Super admin: one login that can view any client's dashboard.
 *
 * The session token issued at sign-in names the client being viewed, so the
 * rest of the app keeps reading `localStorage.username` / `user` and needs no
 * awareness of impersonation. Switching client swaps all three (see
 * applyClientSession in authController).
 */

const SUPER_ADMIN_KEY = "superAdmin";

/** The signed-in operator, or null for an ordinary client session. */
export const getSuperAdmin = () => {
  try {
    const raw = localStorage.getItem(SUPER_ADMIN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Failed to parse stored super admin", error);
    return null;
  }
};

export const isSuperAdmin = () => Boolean(getSuperAdmin()?.username);

export const setSuperAdmin = (superAdmin) => {
  if (superAdmin?.username) {
    localStorage.setItem(SUPER_ADMIN_KEY, JSON.stringify(superAdmin));
  } else {
    localStorage.removeItem(SUPER_ADMIN_KEY);
  }
};

export const clearSuperAdmin = () => localStorage.removeItem(SUPER_ADMIN_KEY);

/** Every account the dropdown may switch into, first user in the DB first. */
export const getSwitchableClients = async () => {
  const response = await api.get("/super_admin/clients", {
    headers: authHeader(),
  });
  return Array.isArray(response.data) ? response.data : [];
};

/**
 * Point the session at `username`. Returns { token, client, super_admin };
 * the caller persists it via applyClientSession.
 */
export const switchClient = async (username) => {
  const response = await api.post(
    "/super_admin/switch_user",
    { username },
    { headers: authHeader() },
  );
  return response.data;
};

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
